module.exports = __webpack_public_path__ + "img/2.3_Associate-Investigators_6_Dawson.f6ffc3cf0160ee1d4f5d96d66d5e41fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.3_Associate-Investigators_6_Dawson.png
// module id = 761
// module chunks = 0